/**
 * Remove empty fields from an object (undefined values removed, empty strings converted to null)
 */
export function removeEmptyFields<T extends Record<string, unknown>>(obj: T): T {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Skip undefined
    if (value === undefined) return acc;

    // Convert empty strings to null
    if (typeof value === 'string' && value.trim() === '') {
      return { ...acc, [key]: null };
    }

    return { ...acc, [key]: value };
  }, {} as T);
}

